import "core-js/modules/es.object.to-string";
import "core-js/modules/web.timers";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';

var ProtocolLog = function (_super) {
  __extends(ProtocolLog, _super);

  function ProtocolLog() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.countdown = 30;
    return _this;
  }

  ProtocolLog.prototype.handleExit = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        window.open('https://www.goodcang.com/', '_self');
        return [2];
      });
    });
  };

  ProtocolLog.prototype.created = function () {
    var _this = this;

    var timer = setInterval(function () {
      _this.countdown--;

      if (_this.countdown <= 0) {
        _this.handleExit();

        clearInterval(timer);
      }
    }, 1000);
  };

  ProtocolLog = __decorate([Component], ProtocolLog);
  return ProtocolLog;
}(Vue);

export default ProtocolLog;